<template>
<div class="ui segments">

  <!-- cart icon -->
  <div class="fabContainer" v-if="itemsInCart>0">
      <div class="faButton" v-on:click="$router.push({name:'cart'})">
          <div class="fabb ui circular google plus icon button">
              <i class="cart icon"></i>
          </div>
      </div>
  </div>
  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Izpildītie pasūtījumi</div>
    </div>
  </div>


  <div class="ui segment" v-bind:class="{ loading: storeStatus.loading }">
    <table class="ui selectable table orange">
      <thead v-if="!checkClientWidth">
        <tr>
          <th>Piegādes datums</th>
          <th>Preces vai pakalpojumi</th>
          <th>Saņemtās preces</th>
          <th>Atpakaļ nodotās preces</th>
          <th>Drošības naudas izmaiņas</th>
          <th>Kopsumma</th>
          <th>Pavadzīme</th>
          <th> </th>
        </tr>
      </thead>
      <tbody v-for="(item,index) in items" class="vertexttop">
        <tr   class="border_bottom abc ">

          <td><span v-if="checkClientWidth">Piegādes datums </span>{{item.delivery_date}}</td>


          <td>
            <div v-for="order in customOrder(item.order_items_list)" >
              <div class="data-div">
              {{ order.goods_name}}
              </div>
            </div>
            <span class="ms-pointer data-div" :id="['par-' + item.id]" v-if="showMoreList(item.order_items_list).length > 0 && !checkClientWidth" v-on:click="loadData(['obj-' + item.id], item.order_items_list), loadGoodWithImage(item.order_items_list,index), customOrder(item.order_items_list)">Vairāk ar bildēm↓</span>
          </td>

          <td v-if="!checkClientWidth">
            <div v-for="order in customOrder(item.order_items_list)" >
               <div style="margin-bottom:10px;min-height:36px;">
               {{order.no_of_goods}}</div>
            </div>
          </td>
          <td v-if="!checkClientWidth">
            <div v-for="order in customOrder(item.order_items_list)" >
             <div style="margin-bottom:10px;min-height:36px;">
             {{ order.no_of_goods_return}}</div>
            </div>
          </td>
          <td v-if="!checkClientWidth">
              <div class="data-div">
                <b data-tooltip="Drošības nauda ar “+” zīmi papildus pieskaitas. Ar “-“ zīmi – atgriežas.">
                {{item.bail}} &euro;
                </b>
              </div>
          </td>
          <td><span v-if="checkClientWidth">Kopsumma </span>{{item.total_amount_with_bail_and_vat}} &euro;</td>
          <td style="white-space: nowrap">
            <a v-if="item.ramus_id != '' " v-on:click="getPdf(item.id)" class="ms-pointer">
            <i class="file pdf outline icon"></i>Pavadzīme</a>
            <a v-if="item.links && item.links.credit_bill" v-on:click="getCreditBillPdf(item.links.credit_bill)" class="ms-pointer">
            <br><i class="file pdf outline icon"></i>Kredītrēķins</a>
          </td>
          <td>

              <div class="ui  button custom_brown" @click="addFullOrderInCart(item)">
               <i class="add icon"></i> Pievienot visu grozam
             </div>
          </td>
        </tr>

          <tr v-if="!checkClientWidth" :class="['obj-' + item.id]" id="hide" v-for="order in showMoreList(item.order_items_list)" >
            <td colspan="2" >
               <img :class="['obj-' + order.id]" v-if="order.image" :src="order.image" alt="test" />
               <img v-else :class="['obj-' + order.id]" :src="['https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/' + order.good_id + '.jpg']" alt="" style="max-height:150px">
            </td>
            <td colspan="2" >
              {{ order.goods_name}}
            </td>
            <td>
              {{ order.no_of_goods}}
            </td>
            <td>
              {{ order.price_per_item}} &euro;
            </td>
            <td colspan="2">
               <div v-if="addedToCart.findIndex(function(elem){return elem==order.good_id})>-1" class="ui green button" >
               Pievienots grozam
              </div>
              <div v-else class="ui  button" @click="addItemToCart(order)">
               <i class="add icon"></i> Pievienot preci grozam
              </div>
            </td>
          </tr>

        <table border=1 frame=void rules=rows></table>
      </tbody>
    </table>
      <paginator :paginator="paginator" link-name="user-invoices-page"></paginator>

  </div>

</div>
</template>

<script>



import Paginator from './Paginator'
import gZoom from './GoodZoom'
import autoShip from './AutoShip';
import price from './Price';
import discount from './Discount';


export default {
  components:{
      Paginator,
      gZoom,
      'auto-ship': autoShip,
      'price-tag': price,
      'discount-tag': discount
  },
  data () {
    return {
      isactive:false,
      addedToCart:[]
    }
  },

  computed: {

    storeStatus() {
      return this.$store.state.invoiceStore.status
    },
    paginator() {
      return this.$store.state.invoiceStore.invoiceExtraData
    },
    cart() {
        return this.$store.state.cartStore.activeCart
    },
    cartItems() {
        return this.$store.state.cartStore.items
    },
    cartItem(){
        var self = this
        var items = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == self.item.id })
        if(items.length > 0){
            return items[0]
        }else{
            return {
                order: 0
            }
        }

    },
    itemsInCart() {
      const sumValues = Object.keys(this.$store.state.cartStore.items).reduce((acc, value) =>  acc + parseInt(this.$store.state.cartStore.items[value].order), 0);
      return  sumValues

    },
    items() {
      return this.$store.state.invoiceStore.items
    },
    checkClientWidth(){
     return document.documentElement.clientWidth < 768
   },

  },


  activated: function() {
    var that=this
    this.isactive = true; //used to ensure that when route keeps changing we dont reload data while component is not visible
    //preload data
    this.loadInvoices();
    this.loadActiveCart();
     setTimeout(function () {
         that.addedToCart.length=0
            that.cartItems.forEach(function(e){
            that.addedToCart.push(e.good_id)
          })
       },500)

  },
  deactivated: function() {
    this.isactive = false;
  },
  watch: {
    '$route.params': 'loadInvoices'
  },

  methods: {
     loadActiveCart: function() {
     this.$store.dispatch('loadActiveCart').then((response) => {

       this.$store.dispatch('loadCartItems', this.cart.id);


     }).catch((error) => {
        if(error.response.status == 404) {
        //if there is no active cart then create new cart
         this.$store.dispatch('createCart')

        }
     });
   },


   loadGoodWithImage(items,key){
     var self = this;
     //for each order item load good and find its first image
      items.forEach((element,i) => {
        this.$store.dispatch('loadSingleGood', element.good_id).then((response) => {
            //if it exists then take first image and load back into ordeitem list
              if(response.data.data.images){

              //  self.$set(items.img,  )
              //set new property
              this.$set(this.items[key].order_items_list[i], 'image', response.data.data.images[0].url)

              }
        }).catch((error) => {


        });
      });



   },

   customOrder: function(item_orders) {
      var arr = [];
      let rentedArray=[]
      let tmpString=""
      this.items.forEach(element => {
        rentedArray.push(element.goods_name)
      });
      tmpString=rentedArray.join();
      if ( item_orders.length >= 5 ) {
        // Push all return goods
        item_orders.map(function(order) {
          if (tmpString.indexOf(order.goods_name)>-1) {
            arr.push(order);
          }
        });
        // Push non-returned goods which has "Memory Water 18,9l BPA free" name
        // item_orders.map(function(order) {
        //   if ( order.no_of_goods_return === "0" && arr.length < 5 ) {
        //     if (order.goods_name === "Memory Water 18,9l BPA free") {
        //       arr.push(order);
        //     }
        //   }
        // });

        // Push non-returned goods which has not "Memory Water 18,9l BPA free" name
        item_orders.map(function(order) {
          if (tmpString.indexOf(order.goods_name)==-1 && arr.length < 5) {
            arr.push(order);
          }
        });
      }

      arr = (arr.length > 0) ? arr : item_orders

      return arr;
   },

   showMoreList: function(item_orders) {
      var arr = [];
      let rentedArray=[]
      let tmpString=""
      this.items.forEach(element => {
        rentedArray.push(element.goods_name)
      });
      tmpString=rentedArray.join();

      if ( item_orders.length > 0 ) {
        item_orders.map(function(order) {
            if (tmpString.indexOf(order.goods_name)>-1) {
            arr.push(order);
          }
        });

        item_orders.map(function(order) {
         if (tmpString.indexOf(order.goods_name)==-1) {
            arr.push(order);
          }
        });
      }
      arr = (arr.length > 0) ? arr : item_orders
      return arr;
    },

    getPdf: function(orderId) {

      this.$store.dispatch('getPdfUrl', orderId).then((response) => {        
    window.location = response.data.url
      }).catch((error) => {
        console.error('error during pdf creation. OrderId: ' + orderId)
      });
    },

    getCreditBillPdf: function (trxId){
      this.$store.dispatch('getTransactionPdfUrl', trxId).then((response) => {
        window.location = response.data.url
      }).catch((error) => {
        console.error('error during pdf creation. Trx: ' + trxId)
      });
    },

    loadInvoices: function() {
      //as this is called by watcher then first check if component is activated
      if (this.isactive) this.$store.dispatch('loadInvoiceStore', [this.$route.params.page, 6]);
    },
    addTableRow: function () {
      this.counter++;
      this.tableRows.push("Table Row "+this.counter);
    },

    loadData: function (id, prodList) {
      var el = $("#" + id[0].replace("obj", "par"));
      if (el.text() === "Vairāk ar bildēm↓" || el.text() === "More ↓") {
        $(el).text("Mazāk↓");
        $("tbody.vertexttop").children('tr').css("background", "");
        $("."+id).closest('tr').parent().children('tr:first').css("background", "#F2F2F2");
        $("."+id).closest('tr').parent().children('tr:first').css("box-shadow", "none");

      }
      else {
        $(el).text("Vairāk ar bildēm↓");
        $("tbody.vertexttop").children('tr').css("background", "");
        $("."+id).closest('tr').parent().children('tr:first').css("background", "#ffffff");
        $("."+id).closest('tr').parent().children('tr:first').css("box-shadow", "0px 2px 7px -2px rgba(122,122,122,1)")
      }
      $("."+id).toggle();
    },
            realPrice(item){
                if(this.checkIfInCart(item)){
                    var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.good_id });
                    return cartItem[0].price_vat;
                }
                else return item.base_price_vat;
            },
            checkIfInCart(item){

                if(this.$store.state.cartStore.items.length > 0 && this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.good_id }).length > 0) return true;
                else return false;
            },
            reduceItemInCart(item){

                $('#good_item_'+item.id).popup('destroy'); //remove warning about warehouse goods

                var itemInCart = this.checkIfInCart(item);
                if(itemInCart){
                var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id });
                var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
                updatedItem.order --;

                this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
                    //if item is totaly removed then remove it from store
                    this.$store.dispatch('loadActiveCart', this.cart.id);
                }).catch((error) => {
                    console.dir(error)
                    console.error('Cart was not loaded')
                });

                }
            },

            addItemToCart(item){
                var self = this
                var itemInCart = this.checkIfInCart(item);
                if(itemInCart){
                  var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.good_id });
                  var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
                  updatedItem.order ++;
                }
                else{
                  var updatedItem = {
                      order:1,
                      good_id:item.good_id
                  }
                }


                this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
                this.addedToCart.push(item.good_id)
                  //show popup that we are out of goods
                  if(response.data.data.order < updatedItem.order) {
                    $('#good_item_'+item.good_id).popup('show')
                    setTimeout(function () { $('#good_item_'+item.good_id).popup('destroy'); }.bind(this), 3000)
                  }
                  else{
                    $('#good_item_'+item.good_id).popup('destroy'); //remove warning about warehouse goods
                  }
                this.$store.dispatch('loadActiveCart', this.cart.id);
                fbq('track', 'AddToCart', {
                                        content_name: response.data.data.name,
                                        content_category: 'Water',
                                        content_ids: [response.data.data.good_id],
                                        content_type: 'product',
                                        value: response.data.data.price_vat,
                                        currency: 'EUR'
                                    });

                }).catch((error) => {
                console.dir(error)
                console.error('Cart was not loaded')
                });

            },
            howManyInCart(item){
                if(this.checkIfInCart(item)){
                var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.good_id });
                item.autoship_price = cartItem[0].autoship_price;
                return cartItem[0].order;
                }
                else return 0;
            },
            updateCartItemReturn: _.debounce(function(returnItems) {
                var self = this
                if(this.item != undefined && this.checkIfInCart(this.item)){
                    var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == self.item.good_id });
                    var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
                    updatedItem.return = returnItems;
                    this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
                        this.$store.dispatch('loadActiveCart', this.cart.id);
                    }).catch((error) => {
                        console.error('Cart was not loaded')
                    });
                }
            }, 500),
            updateCartItemOrder: _.debounce(function(order) {
                var self = this
                if(order == "") return;
                //if(order == 0) this.removeItem(item)
                else {
                    if(this.item != undefined && this.checkIfInCart(this.item)){
                        var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == self.item.good_id });
                        var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
                        updatedItem.order = order;
                    }
                    else{
                        var updatedItem = {
                            order:order,
                            good_id:this.item.good_id
                        }
                    }

                    this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
                        this.$store.dispatch('loadActiveCart', this.cart.id);
                        self.item.order = updatedItem.order
                    }).catch((error) => {
                        console.error('Cart was not loaded')
                    });
                }

            }, 500),

            gotoMoreDescription: function(){
                $(window).scrollTop($('#long-description').offset().top);
            },

            loadActiveCart() {
              this.$store.dispatch('loadActiveCart').then((response) => {

                this.$store.dispatch('loadCartItems', response.data.data.id);
              }).catch((error) => {
                 if(error.response && error.response.status == 404) {
                 //if there is no active cart then create new cart
                  this.$store.dispatch('createCart')
                 }
              });
            },
            addFullOrderInCart(item) {
              //alert(item.id);

              this.$store.dispatch('convertOrderToCart', item).then((response) => {
                this.addedToCart.length=0
                this.addedToCart.push(item.id)
                // location.reload();
                 this.loadActiveCart();
                // this.$router.push({
                //     name: 'waiting-for-delivery-edit',
                //     params: {
                //         id: response.data.data.id
                //     }
                // });

              }).catch((error) => {
                console.error(error)
                console.error('Order conversion failed')
              });

              this.$store.dispatch('loadActiveCart', this.cart.id);
            }
}


}
</script>

<style>
.ms-pointer {
  cursor: pointer;
}
.removeborder{
  box-shadow:none!important;
}
.data-div {
    margin: 0px 10px 10px 10px;
    min-height:36px;
}
.vertexttop td{
  vertical-align:top;
}
.ms-pointer {
  cursor: pointer;
}
#hide {
  display: none;
}
#wid-100 {
  width: 100% !important;
}
#hide{background: rgba(0,0,0,.05)!important}

.fabContainer{
  position: fixed;
  margin-left: 1086px;
  bottom: 50px;
  background: none;

  border: none;
  text-align: right;
  z-index: 10;
}
.fabb.button{
  font-size: 1.5rem !important;
}


@media (max-width:767px) {
    .fabContainer {
        right: 0px
    }
}

@media (min-width:768px) {
    .fabContainer {
        margin-left: 675px
    }
}

@media (min-width:992px) {

    .fabContainer  {
        margin-left: 895px
    }
}

@media (min-width:1260px) {
    .fabContainer {
        margin-left: 1086px
    }
}

@media (min-width:1280px) {
    .fabContainer {
        margin-left: 1086px
    }
}

.badge-wrapper {
    display: flex;
  }
tr.border_bottom.abc {
  border-bottom:1pt solid black;
  box-shadow: 0px 2px 7px -2px rgba(122,122,122,1);
}

tr.border_bottom{
  border-bottom:none;
  box-shadow: none;
}

</style>



// WEBPACK FOOTER //
// UserInvoicesPage.vue?7d9caa0c